import { Action } from '@ngrx/store';
import { GlobalSettings } from '../shared/domain/configuration.model';

export const GET_GLOBAL_SETTINGS = 'GET_GLOBAL_SETTINGS';
export const GET_GLOBAL_SETTINGS_SUCCESS = 'GET_GLOBAL_SETTINGS_SUCCESS';
export const GET_GLOBAL_SETTINGS_FAILURE = 'GET_GLOBAL_SETTINGS_FAILURE';

export const UPDATE_GLOBAL_SETTINGS = 'UPDATE_GLOBAL_SETTINGS';
export const UPDATE_GLOBAL_SETTINGS_SUCCESS = 'UPDATE_GLOBAL_SETTINGS_SUCCESS';
export const UPDATE_GLOBAL_SETTINGS_FAILURE = 'UPDATE_GLOBAL_SETTINGS_FAILURE';

export class GetGlobalSettingsAction implements Action {
  readonly type = GET_GLOBAL_SETTINGS;

  constructor(public payload?: any) {}
}

export class GetGlobalSettingsSuccessAction implements Action {
  readonly type = GET_GLOBAL_SETTINGS_SUCCESS;

  constructor(public payload: GlobalSettings) {}
}

export class GetGlobalSettingsFailureAction implements Action {
  readonly type = GET_GLOBAL_SETTINGS_FAILURE;

  constructor(public payload: any) {}
}

export class UpdateGlobalSettingsAction implements Action {
  readonly type = UPDATE_GLOBAL_SETTINGS;

  constructor(public payload: GlobalSettings) {}
}

export class UpdateGlobalSettingsSuccessAction implements Action {
  readonly type = UPDATE_GLOBAL_SETTINGS_SUCCESS;

  constructor(public payload: GlobalSettings) {}
}

export class UpdateGlobalSettingsFailureAction implements Action {
  readonly type = UPDATE_GLOBAL_SETTINGS_FAILURE;

  constructor(public payload: any) {}
}

export type GlobalSettingsAction =
  | GetGlobalSettingsAction
  | GetGlobalSettingsSuccessAction
  | GetGlobalSettingsFailureAction
  | UpdateGlobalSettingsAction
  | UpdateGlobalSettingsSuccessAction
  | UpdateGlobalSettingsFailureAction;
